import { useEffect } from 'react';

export default function MapNotification({ notification, onDismiss, onUndo }) {
  const { id, message, variant, undo } = notification;
  const persistent = variant === 'error' || variant === 'warning';
  useEffect(() => {
    if (persistent) return undefined;
    const timer = setTimeout(() => onDismiss(id), undo ? 5200 : 5000);
    return () => clearTimeout(timer);
  }, [id, persistent, onDismiss, undo]);
  return (
    <div className={`mind-map-notification mind-map-notification--${variant}`}>
      <span role={variant === 'error' ? 'alert' : 'status'} aria-atomic="true">{message}</span>
      {undo && onUndo && (
        <button type="button" className="mind-map-notification__undo"
          onClick={() => {
            onDismiss(id, true);
            onUndo();
          }}>Undo</button>
      )}
      <button type="button" className="mind-map-notification__dismiss" aria-label={`Dismiss: ${message}`}
        onClick={() => onDismiss(id, true)}>×</button>
    </div>
  );
}
